<template>
  <div class="point-row">
    <div class="content">
      <img
        class="icon"
        :class="'icon'+level"
        src="@/assets/images/point/jia.png"
        v-if="data.children&&data.children.length&&!data.expand"
        @click="onExpand"
      />
      <img
        class="icon"
        :class="'icon'+level"
        src="@/assets/images/point/jian.png"
        v-else-if="data.children&&data.children.length&&data.expand"
        @click="onExpand"
      />
      <span v-if="!data.children||!data.children.length" class="icon icon-point"></span>
      <div class="main" @click="handleClick(data,number)">
        <div class="name-container clear">
          <div class="name f-left">{{data.name}}</div>
          <div class="f-right" 
               style="width:4.53333vw;"
               @click="$router.push({name:'Ques',query:{id:data.id,number:number,type:'Point'}})">
            <img
              v-if="data.question_amount>0"
              src="@/assets/images/point/arrow@2x.png"
              style="width:1.86667vw;"
            />
          </div>
        </div>
        <div class="statis clear">
          <div class="f-left">正确率：{{parseInt((parseFloat(data.correct_rate)*100).toFixed(2))}}%</div>
          <div class="f-right">{{data.finished_amount||0}}/{{data.question_amount}}</div>
        </div>
        <div class="progress">
          <div
            class="progress-complete"
            v-if="data.question_amount>0"
            :style="{'width':data.finished_amount/data.question_amount*100+'%'}"
          ></div>
        </div>
      </div>
    </div>
    <div class="child" v-if="data.expand">
      <PointRow
        v-for="child in data.children"
        :key="child.id"
        :data="child"
        :number="number"
        :level="level+1"
      ></PointRow>
    </div>
  </div>
</template>
<script>
export default {
  name: "PointRow",
  props: {
    data: {
      type: Object
    },
    number: {
      type: Number
    },
    level: {
      type: Number,
      default: 1
    }
  },
  created() {
    this.$set(this.data, "expand", false);
  },
  methods: {
    handleClick(data,number){
      if(data.children && data.children.length) {//有子级展开自己
        this.onExpand();
      } else{//无子级进入做题页
        this.$router.push({name: 'Ques',query: {id: data.id,number: number, type: 'Point'}});
      }
    },
    onExpand() {
      if (!this.data.children || this.data.children.length == 0) {
        return;
      }
      this.data.expand = !this.data.expand;
      if (this.data.expand) {
        this.$emit("onExpand", this.data.id);
      }
    }
  },
  watch: {
    data() {
      this.$set(this.data, "expand", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.point-row {
  margin-bottom: 43px;
  &:last-child {
    margin-bottom: 0;
  }
}
.content {
  display: flex;
  align-items: center;
  position: relative;
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    &.icon1 {
      width: 28px;
    }
    &.icon2 {
      width: 26px;
      left: 1px;
    }
    &.icon3 {
      width: 24px;
      left: 2px;
    }
  }
  .icon-point {
    position: absolute;
    transform: translateY(-50%);
    background-color: $theme_color;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    left: 4px;
  }
  .main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin-left: 50px;
    .name-container {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
      line-height: 26px;
      margin-bottom: 29px;
      .name{
        line-height: 30px;
      }
    }
    .statis {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      line-height: 22px;
      margin-bottom: 14px;
      .f-left{
        line-height: 30px;
      }
    }
    .progress {
      height: 6px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      overflow: hidden;
      .progress-complete {
        height: 100%;
        background: $theme-color;
      }
    }
  }
}
.child {
  margin-top: 43px;
}
</style>